import { useAuth0 } from '@auth0/auth0-react';
import * as React from 'react';

export interface RBACContext {
  roles: string[];
}
export const RBACContext = React.createContext<RBACContext>(undefined);

export const RBACProvider = ({ children }) => {
  const { getIdTokenClaims, isAuthenticated } = useAuth0();
  const [claims, setClaims] = React.useState<any>(undefined);
  const [roles, setRoles] = React.useState<string[]>();

  React.useEffect(() => {
    async function userClaims() {
      if (isAuthenticated) {
        try {
          const idTokenClaims = await getIdTokenClaims();
          setClaims(idTokenClaims);
        } catch (e) {
          setClaims({ ['https://sero-digital.sero.life/roles']: [] });
        }
      }
    }

    userClaims();
  }, [isAuthenticated]);

  React.useEffect(() => {
    async function userRoles() {
      if (claims) setRoles(claims?.['https://sero-digital.sero.life/roles'] || []);
    }

    userRoles();
  }, [claims]);
  return (
    <RBACContext.Provider
      value={{
        roles,
      }}
    >
      {children}
    </RBACContext.Provider>
  );
};

export const useRBAC = () => React.useContext(RBACContext);
